export const LOCALES = ["en", "es"] as const;

export type LocaleCode = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: LocaleCode = "en";

export function isLocale(value: unknown): value is LocaleCode {
  return typeof value === "string" && (LOCALES as readonly string[]).includes(value);
}

/**
 * Locale-scoped UI messages used by shared interface chrome, auth, and errors.
 */
export interface LocaleMessages {
  actions: {
    backToHome: string;
    copyLink: string;
    copyLinkSuccess: string;
    openMenu: string;
    closeMenu: string;
    share: string;
    signIn: string;
    signingIn: string;
    signOut: string;
    submit: string;
    submitting: string;
    switchLanguage: string;
  };
  auth: {
    loggedInAs: string;
    mockOnly: string;
    seededAccounts: string;
    seedHint: string;
    useCredentials: string;
  };
  common: {
    description: string;
    email: string;
    formErrors: string;
    loading: string;
    optional: string;
    password: string;
    required: string;
    skipToContent: string;
    toggleNav: string;
  };
  consent: {
    accept: string;
    decline: string;
    description: string;
    learnMore: string;
    title: string;
  };
  dashboard: {
    accountNav: string;
    adminNav: string;
    overviewNav: string;
    signedOut: string;
    welcome: string;
  };
  errors: {
    boundaryHint: string;
    boundaryTitle: string;
    notFoundIntro: string;
    notFoundTitle: string;
    unknownLocale: string;
  };
  share: {
    email: string;
    linkedin: string;
    native: string;
    twitter: string;
  };
  sitemap: {
    jumpToSection: string;
  };
}

export type Messages = LocaleMessages;
